var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-document",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: false,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "cw-pdf-main-container",
                    },
                    [
                      _vm.hasFile
                        ? [
                            _vm.currentTitle !== ""
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "cw-block-title",
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.currentTitle) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "cw-pdf-toolbar",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "cw-pdf-toolbar-left",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cw-pdf-toc",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "undecorated",
                                            class: {
                                              active: _vm.pdfTOCDisplay,
                                            },
                                            attrs: {
                                              title:
                                                _vm.$gettext(
                                                  "Inhaltsverzeichnis"
                                                ),
                                              "aria-pressed": _vm.pdfTOCDisplay
                                                ? "true"
                                                : "false",
                                            },
                                            on: {
                                              click: _vm.toggleTOCViewer,
                                            },
                                          },
                                          [
                                            _c("studip-icon", {
                                              staticClass: "text-bottom",
                                              attrs: {
                                                shape: "table-of-contents",
                                                role:
                                                  _vm.pdfTOC.length === 0
                                                    ? "inactive"
                                                    : _vm.pdfTOCDisplay
                                                    ? "info_alt"
                                                    : "clickable",
                                                size: 18,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cw-pdf-search-toggle-btn",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "undecorated",
                                            class: {
                                              active: _vm.showPdfSearchBox,
                                            },
                                            attrs: {
                                              title: _vm.$gettext("Suche"),
                                              "aria-pressed":
                                                _vm.showPdfSearchBox
                                                  ? "true"
                                                  : "false",
                                            },
                                            on: {
                                              click: _vm.togglePdfSearchBox,
                                            },
                                          },
                                          [
                                            _c("studip-icon", {
                                              staticClass: "text-bottom",
                                              attrs: {
                                                shape: "search",
                                                role: _vm.showPdfSearchBox
                                                  ? "info_alt"
                                                  : "clickable",
                                                size: 18,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.showPdfSearchBox,
                                            expression: "showPdfSearchBox",
                                          },
                                        ],
                                        staticClass: "cw-pdf-search-box",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.pdfSearch,
                                              expression: "pdfSearch",
                                            },
                                          ],
                                          ref: "pdfSearchInput",
                                          attrs: {
                                            type: "text",
                                          },
                                          domProps: {
                                            value: _vm.pdfSearch,
                                          },
                                          on: {
                                            change: _vm.doSearchInPdf,
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.pdfSearch =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.pdfSearchFoundNums > 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cw-pdf-search-navs",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass: "undecorated",
                                                    attrs: {
                                                      title:
                                                        _vm.$gettext("Letzte"),
                                                    },
                                                    on: {
                                                      click: _vm.prevPdfSearch,
                                                    },
                                                  },
                                                  [
                                                    _c("studip-icon", {
                                                      staticClass:
                                                        "text-bottom",
                                                      attrs: {
                                                        shape: "arr_1left",
                                                        role:
                                                          _vm.pdfSearchFoundSelectedIndex ===
                                                          0
                                                            ? "inactive"
                                                            : "clickable",
                                                        size: 18,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass: "undecorated",
                                                    attrs: {
                                                      title:
                                                        _vm.$gettext("Nächste"),
                                                    },
                                                    on: {
                                                      click: _vm.nextPdfSearch,
                                                    },
                                                  },
                                                  [
                                                    _c("studip-icon", {
                                                      staticClass:
                                                        "text-bottom",
                                                      attrs: {
                                                        shape: "arr_1right",
                                                        role:
                                                          _vm.pdfSearchFoundSelectedIndex ===
                                                          _vm.pdfSearchFoundNums -
                                                            1
                                                            ? "inactive"
                                                            : "clickable",
                                                        size: 18,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.pdfSearchFoundNums > 0
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "cw-pdf-search-num",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.pdfSearchFoundSelectedIndex +
                                                        1
                                                    ) +
                                                    " / " +
                                                    _vm._s(
                                                      _vm.pdfSearchFoundNums
                                                    ) +
                                                    "\n                                    " +
                                                    _vm._s(
                                                      _vm.$gettext("Treffer")
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cw-pdf-page-nav",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "undecorated",
                                            attrs: {
                                              title:
                                                _vm.$gettext(
                                                  "Eine Seite zurück"
                                                ),
                                            },
                                            on: {
                                              click: _vm.prevPage,
                                            },
                                          },
                                          [
                                            _c("studip-icon", {
                                              staticClass: "text-bottom",
                                              attrs: {
                                                shape: "arr_1up",
                                                role:
                                                  _vm.pageNum - 1 === 0
                                                    ? "inactive"
                                                    : "clickable",
                                                size: 18,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "undecorated",
                                            attrs: {
                                              title:
                                                _vm.$gettext("Eine Seite vor"),
                                            },
                                            on: {
                                              click: _vm.nextPage,
                                            },
                                          },
                                          [
                                            _c("studip-icon", {
                                              staticClass: "text-bottom",
                                              attrs: {
                                                shape: "arr_1down",
                                                role:
                                                  _vm.pageNum === _vm.pageCount
                                                    ? "inactive"
                                                    : "clickable",
                                                size: 18,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          ref: "pageNumInput",
                                          staticClass: "cw-pdf-page-num",
                                          attrs: {
                                            type: "text",
                                            "aria-label": _vm.$gettext("Seite"),
                                          },
                                          domProps: {
                                            value: _vm.pageNum,
                                          },
                                          on: {
                                            change: _vm.updatePageNum,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$gettext("von")) +
                                              " " +
                                              _vm._s(_vm.pageCount) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "cw-pdf-toolbar-middle",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cw-pdf-zoom-buttons",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "undecorated",
                                            attrs: {
                                              title: _vm.$gettext("Vergrößern"),
                                            },
                                            on: {
                                              click: _vm.zoomIn,
                                            },
                                          },
                                          [
                                            _c("studip-icon", {
                                              staticClass: "text-bottom",
                                              attrs: {
                                                shape: "add",
                                                size: 18,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "undecorated",
                                            attrs: {
                                              title:
                                                _vm.$gettext("Verkleinern"),
                                            },
                                            on: {
                                              click: _vm.zoomOut,
                                            },
                                          },
                                          [
                                            _c("studip-icon", {
                                              staticClass: "text-bottom",
                                              attrs: {
                                                shape: "remove",
                                                size: 18,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.currentScale,
                                                expression: "currentScale",
                                              },
                                            ],
                                            attrs: {
                                              "aria-label":
                                                _vm.$gettext("Zoom"),
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.currentScale = $event
                                                    .target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                },
                                                _vm.updateZoom,
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: false,
                                                    expression: "false",
                                                  },
                                                ],
                                                domProps: {
                                                  value: _vm.currentScale,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.formattedZoom) +
                                                    "%"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.scaleValues,
                                              function (value, index) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: index,
                                                    domProps: {
                                                      value: value.scale,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(value.name) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cw-pdf-rotate",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "undecorated",
                                            attrs: {
                                              title: _vm.$gettext("Drehen"),
                                            },
                                            on: {
                                              click: _vm.doRotatePdf,
                                            },
                                          },
                                          [
                                            _c("studip-icon", {
                                              staticClass: "text-bottom",
                                              attrs: {
                                                shape: "rotate-right",
                                                size: 18,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "cw-pdf-toolbar-right",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cw-pdf-handtool",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "undecorated",
                                            class: {
                                              active: _vm.pdfHandTool,
                                            },
                                            attrs: {
                                              title:
                                                _vm.$gettext("Hand-Werkzeug"),
                                              "aria-pressed": _vm.pdfHandTool
                                                ? "true"
                                                : "false",
                                            },
                                            on: {
                                              click: _vm.toggleHandTool,
                                            },
                                          },
                                          [
                                            _c("studip-icon", {
                                              staticClass: "text-bottom",
                                              attrs: {
                                                shape: "hand",
                                                role: _vm.pdfHandTool
                                                  ? "info_alt"
                                                  : "clickable",
                                                size: 18,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cw-pdf-download",
                                      },
                                      [
                                        _vm.downloadable === "true"
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: _vm.currentUrl,
                                                  download: "",
                                                  title:
                                                    _vm.$gettext("Speichern"),
                                                },
                                              },
                                              [
                                                _c("studip-icon", {
                                                  staticClass: "text-bottom",
                                                  attrs: {
                                                    shape: "download",
                                                    size: 18,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                ref: "outerContainer",
                                staticClass: "cw-pdf-outer-container",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "cw-pdf-content",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "sr-only",
                                        attrs: {
                                          "aria-live": "polite",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.srMessage))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.pdfTOCDisplay,
                                            expression: "pdfTOCDisplay",
                                          },
                                        ],
                                        staticClass: "cw-pdf-sidebar",
                                      },
                                      [
                                        _c(
                                          "ul",
                                          {
                                            staticClass: "cw-pdf-toc-list",
                                          },
                                          _vm._l(
                                            _vm.pdfTOC,
                                            function (item, index) {
                                              return _c(
                                                "CoursewarePDFTableOfContent",
                                                {
                                                  key: index,
                                                  attrs: {
                                                    item: item,
                                                  },
                                                  on: {
                                                    tocPageNav: _vm.tocPageNav,
                                                  },
                                                }
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "dragscroll",
                                            rawName: "v-dragscroll",
                                            value: _vm.pdfHandTool,
                                            expression: "pdfHandTool",
                                          },
                                        ],
                                        ref: "container",
                                        staticClass: "cw-pdf-viewer-container",
                                        class: {
                                          "hand-cursor-grab": _vm.pdfHandTool,
                                          grabbing: _vm.pdfGrabbing,
                                          "has-error": _vm.pdfError,
                                        },
                                        on: {
                                          mousedown: _vm.handleMouseDown,
                                          mouseup: _vm.handleMouseUp,
                                        },
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "pdfViewer",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.pdfError,
                                        expression: "pdfError",
                                      },
                                    ],
                                    staticClass: "cw-pdf-error-page",
                                  },
                                  [
                                    _c("courseware-companion-box", {
                                      attrs: {
                                        mood: "sad",
                                        msgCompanion: _vm.$gettext(
                                          "Es gab einen Fehler. Bitte versuchen Sie es erneut!"
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    ref: "fakeContainer",
                                    staticClass: "cw-pdf-viewer-fake-container",
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "pdfViewer",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Überschrift")) +
                                "\n                    "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentTitle,
                                  expression: "currentTitle",
                                },
                              ],
                              attrs: {
                                type: "text",
                              },
                              domProps: {
                                value: _vm.currentTitle,
                              },
                              on: {
                                input: function input($event) {
                                  if ($event.target.composing) return
                                  _vm.currentTitle = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Datei")) +
                                  "\n                    "
                              ),
                              _c("studip-file-chooser", {
                                attrs: {
                                  selectable: "file",
                                  courseId: _vm.context.id,
                                  userId: _vm.userId,
                                  isDocument: true,
                                  excludedCourseFolderTypes:
                                    _vm.excludedCourseFolderTypes,
                                },
                                model: {
                                  value: _vm.currentFileId,
                                  callback: function callback($$v) {
                                    _vm.currentFileId = $$v
                                  },
                                  expression: "currentFileId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Download-Icon anzeigen")) +
                                "\n                    "
                            ),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentDownloadable,
                                    expression: "currentDownloadable",
                                  },
                                ],
                                on: {
                                  change: function change($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.currentDownloadable = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "true",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$gettext("Ja")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "false",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$gettext("Nein")))]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Dateityp")) +
                                "\n                    "
                            ),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentDocType,
                                    expression: "currentDocType",
                                  },
                                ],
                                on: {
                                  change: function change($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.currentDocType = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "pdf",
                                    },
                                  },
                                  [_vm._v("PDF")]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$gettext("Informationen zum Dokument-Block"))
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }